// Shared yup helpers for the auth forms. Schema messages are i18n keys,
// translated at render time.

import * as yup from 'yup';

export type FormErrors = Record<string, string | undefined>;

/** Validate all values; returns a path→message-key map (empty when valid). */
export const validateAll = async (
  schema: yup.AnyObjectSchema,
  values: object,
): Promise<FormErrors> => {
  try {
    await schema.validate(values, { abortEarly: false });
    return {};
  } catch (err) {
    const errors: FormErrors = {};
    if (err instanceof yup.ValidationError) {
      for (const inner of err.inner) {
        if (inner.path && !errors[inner.path]) errors[inner.path] = inner.message;
      }
    }
    return errors;
  }
};

/** Validate a single field; returns its message key, or undefined when valid. */
export const validateField = async (
  schema: yup.AnyObjectSchema,
  name: string,
  values: object,
): Promise<string | undefined> => {
  try {
    await schema.validateAt(name, values);
    return undefined;
  } catch (err) {
    return err instanceof yup.ValidationError ? err.message : undefined;
  }
};
